import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { withSnackbar } from 'notistack';

import { withStyles } from '@material-ui/core/styles';
import { AgGridReact } from 'ag-grid-react';
import { Button, Typography, Grid } from '@material-ui/core';

import { AccountHandler, SubscriberHandler } from 'chits-data/dist';
import Constants from 'components/utils/constants';
import LoadingOverlay from 'components/common/loadingOverlay';
import mapStateToProps from 'reducers/actions/stateToProps';
import { AccountStyle } from 'components/account/AccountStyle';
import mapDispatchToProps from 'reducers/actions/dispatchProps';

import './Subscriber.css';
import AssignSubscriber from './AssignSubscriber';
let console = Constants.consoleWrapper(false);
class SubscribersManager extends React.Component {

  constructor(props) {
    super(props);
    this._isMounted = false; // prevents -> Warning: Can't perform a React state update on an unmounted component
    this._accountHandler = new AccountHandler();
    this._handler = new SubscriberHandler();
  }
  
  state = {
    open: {
      openNewSubscriber: false,
    },
    roles: Constants.extractRolesFromAccount(this.props.selectedAccount),
    openOverlay: false,
    selectedAccount: this.props.selectedAccount,
    subscribers: [],
    subscriberNames: {},
    enableAssignSubscriber: false,
    enableUnAssignSubscriber: false,
    subscriberEditMode: false,
    subscriberRowsSelected: [],
    clearCache: this.props.appState.clearCache
  };

  componentDidMount() {
    this.handleGetSubscribers();
  }

  handleGetSubscribers() {
    this.setState({
      openOverlay: true
    })
    let { _id } = this.state.selectedAccount;
    let clearCache = this.state.clearCache;
    this._accountHandler.getAccountSubscribersCached(_id, clearCache).then((accountSubscribers) => {
      console.debug('SubscribersManager -> handleGetSubscribers() -> accountSubscribers', accountSubscribers)
      // If I'm the owner of the account then link account subscribers to my contact; 
      // If not (example, shared viewer) can only see the name of the subscriber
      if (this.state.roles.owner) {
        this.handleAssociateAccountSubsToMyContacts(accountSubscribers);
      } else {
        this.setState({
          subscribers: accountSubscribers,
          openOverlay: false,
        })
        this.props.setSubscribers(accountSubscribers);
      }
      
    }).finally(()=>this.setState({ clearCache: false }))
  }

  handleAssociateAccountSubsToMyContacts = (accountSubscribers) => {
    this._handler.getSubscribersCached().then((allSubscribers)=>{
      console.debug('myContacts', allSubscribers)
      let subscriberNames = allSubscribers.reduce((obj, sub)=>{
        obj[sub._id] = {
          name: sub.fname + " " + sub.lname,
          cell: sub.isd_code + sub.cell
        }
        return obj;
      },{});
      let _subscribers = accountSubscribers.reduce((arr, sub) => {
        // override the name
        if (sub.id) {
          let subInfo = subscriberNames[sub.id];
          if (subInfo) {
            let {name, cell} = subInfo;
            if (name) sub.name = name;
            if (cell) sub.cell = cell;
          }
          if (sub.assignedOn) sub.assignedOnAgo = Constants.timeAgo(sub.assignedOn);
        }
        arr.push(sub);
        return arr;
      },[]);
      this.setState({
        subscribers: _subscribers,
        openOverlay: false,
      })
      this.props.setSubscribers(_subscribers);
    })
  }

  handleOpenModal = (modal = "subscriber-add") => {
    let showModal = this.state.open;
    showModal.openNewSubscriber = (modal === "subscriber-assign" || modal === "subscriber-edit");

    this.setState({
      open: showModal,
      subscriberEditMode: (modal === "subscriber-edit")
    })
  }

  handleCloseModal = (modal = "subscriber") => {
    let showModal = this.state.open;
    showModal.openNewSubscriber = false;
    this.setState({
      open: showModal,
      enableAssignSubscriber: false,
      clearCache: true 
    });
    if (modal === "subscriber" || modal === "subscriber-assign") {
      this.handleGetSubscribers()
    }
  };

  onSharingSelectionChanged() {
    let selectedRows = this.sharingGridApi.getSelectedRows();
    let selectedSubscriber = selectedRows[0];
    console.debug("selectedSubscriber", selectedSubscriber)
    this.setState({
      subscriberRowsSelected: selectedRows,
      enableAssignSubscriber: (this.state.roles.owner || this.state.roles.admin) && selectedSubscriber && !selectedSubscriber.id,
      enableUnAssignSubscriber: (this.state.roles.owner || this.state.roles.admin) && selectedSubscriber && selectedSubscriber.id,
    })
  }

  handleOnSharingGridReady = params => {
    this.sharingGridApi = params.api;
    this.sharingGridColumnApi = params.columnApi;
    this.sharingGridApi.sizeColumnsToFit();
  };

  renderSubscriberModal() {
    return (
      <AssignSubscriber 
        display={true}
        onCancel={()=>this.handleCloseModal("subscriber-assign")}
        subscriber={this.state.subscriberRowsSelected[0]}
        account={this.state.selectedAccount}
        mode="assign"
        onSubmit={()=>this.handleCloseModal("subscriber-assign")}
        onError={()=>this.handleCloseModal("subscriber-assign")}
        />
    )
  }

  handleOnCellValueChanged = (params) => {
    let _ac = this.state.selectedAccount._id;
    var colId = params.column.getId();
    if (colId === 'name') {
        let { index, name } = params.data;
        this._accountHandler.updateSubscriberDetails( _ac, index, { index, name })
        .then(()=>{
          Constants.requestTranRefresh();
        })
        .catch((error)=>{
          console.error(error)
          let msg = error.message;
          try {
            if (error.response.data.message) msg = error.response.data.message;
          } catch (err) {}
          try {
              if (error.response.data.error) msg = error.response.data.error;
          } catch (err) {}
          this.props.enqueueSnackbar(msg, {variant: 'error'});
        })
        .finally(()=>{
          window.location.href += '?refresh=sub_name_change';
        })
    }
  }

  handleUnAssignSubscriber = () => {
    let subscriberId = this.state.subscriberRowsSelected[0].id;
    let accountId = this.state.selectedAccount._id;
    let { index, oldName } = this.state.subscriberRowsSelected[0];
    this._handler.unAssignSubscriberToChitfund(subscriberId, accountId, index, oldName).then(()=>{
      window.location.href += '?refresh=sub_name_change';
    })
  }

  renderSharingActions() {
    return (
      <Grid container>
        <Grid item md={12} sm={12} xs={12}>
          {this.state.enableAssignSubscriber && <Button disabled={!this.state.enableAssignSubscriber}
            onClick={() => this.handleOpenModal("subscriber-assign")}
            variant="contained"
            size="medium"
            color="primary">
            Link a Contact<i className="pe-7s-add-user"></i></Button>}
        {this.state.enableUnAssignSubscriber && <Button disabled={!this.state.enableUnAssignSubscriber}
            onClick={() => this.handleUnAssignSubscriber()}
            variant="contained"
            size="medium"
            color="secondary">
            Unlink Contact <i className="pe-7s-delete-user"></i></Button>}
      </Grid>
      </Grid>
    )
  }

  renderSubscribersGrid() {
    const { classes } = this.props;
    const agStyles = `ag-theme-balham ${classes.agThemeModified}`;
    return (
      <Grid container id='accountinfo-subscribers-grid' 
        style={{ height: "100vh", width: "100%", 
        margin: '4px 2px 0px 2px', padding: '4px 6px 0px 2px'}} 
        >
        <Grid item /*xl={4} lg={6} md={6} sm={6}*/ xs={12}>
          {this.renderSharingActions()}
          {(this.state.subscribers.length === 0) &&
            <Typography>Subscribers are not setup yet on this account.</Typography>}
          {(this.state.subscribers.length > 0) && <div className={agStyles}>
            <AgGridReact
              gridOptions={{
                defaultColDef: {
                  resizable: true,
                  sortable: false,
                },
                onCellValueChanged: this.handleOnCellValueChanged,
                getRowStyle: params => {
                  if (params.data.id) {
                    return { background: Constants.COLORs.SABBU };
                  }
                },
                  
              }}
              // onRowDragEnter={this.onRowDragEnter}
              // onRowDragEnd={this.onRowDragEnd}
              onGridReady={this.handleOnSharingGridReady}
              // onRowDragLeave={this.onRowDragLeave}
              //TODO: Move to dynamic columns like AccountGrid/SubscriberGrid
              columnDefs={[{
                headerName: "#",
                field: "index",
                width: 22,
                cellStyle:(params)=>{
                  return {
                    'padding-left': '2px',
                    'padding-right': '0px',
                    'padding-top': '0px',
                    'padding-bottom': '0px'
                  }
                }
              },{
                headerName: "Name",
                field: "name",
                width: 100,
                editable: true,
                // cellEditor: 'popupTextEditor',
                // pinned: 'left'
                cellStyle:(params)=>{
                  return {
                    'padding-left': '2px',
                    'padding-right': '0px',
                    'padding-top': '0px',
                    'padding-bottom': '0px'
                  }
                }
              }, {
              //   headerName: "Subscriber sid",
              //   field: "sid",
              //   width: 80
              // }, {
                headerName: "Mobile",
                field: "cell",
                width: 80,
                cellStyle:(params)=>{
                  return {
                    'padding-left': '2px',
                    'padding-right': '0px',
                    'padding-top': '0px',
                    'padding-bottom': '0px'
                  }
                }
              }/*, {
                headerName: "Assigned On",
                field: "assignedOnAgo",
                width: 180
              }*/, {
                headerName: "Lift",
                field: "isBid",
                width: 40,
                cellRenderer: (params) => {
                  return params.value ? 'Yes' : 'No';
                },
                cellStyle:(params)=>{
                  if (params.value)
                    return {
                      color: '#125d12',
                      'background-color': '#2eca2e',
                      'font-size': 'small',
                      'text-align': 'left'
                    }
                  else 
                    return {
                      color: '#710000',
                      'background-color': '#d48590',
                      'font-size': 'small',
                      'text-align': 'left'
                    }
                }
              // },{
              //   header: "Account",
              //   field: "ac",
              //   width: 180,
              //   cellRenderer: (params) => {
              //     // return params.value;
              //     return `<a href="${"/transactions/" + params.value}" target="_blank">${params.value}</a>`;
              //   }
              }]}
              rowData={this.state.subscribers}
              // getRowClass={this.handleRowHighlights}
              rowSelection="single"
              onSelectionChanged={this.onSharingSelectionChanged.bind(this)}
              // rowDragManaged={true}
              animateRows
              // pagination={!this.state.gridEditMode}
              // paginationPageSize={25}
              enableCellTextSelection="true"
              ensureDomOrder="true"
            />
          </div>}
        </Grid>
      </Grid>
    )
  }

  render() {
    return (
      <div>
        {this.renderSubscribersGrid()}
        {this.state.open.openNewSubscriber && this.renderSubscriberModal()}
        {this.state.openOverlay && <LoadingOverlay />}
      </div>
    )
  }
}

SubscribersManager.propTypes = {
  classes: PropTypes.object.isRequired,
  display: PropTypes.bool.isRequired,
  selectedAccount: PropTypes.object.isRequired,
  roles: PropTypes.object.isRequired
}

export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar(withStyles(AccountStyle)(SubscribersManager)));
